import { render, staticRenderFns } from "./GraphCard.vue?vue&type=template&id=63740fbe&"
import script from "./GraphCard.vue?vue&type=script&lang=ts&"
export * from "./GraphCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports